import { Component, Input, OnInit } from '@angular/core';
import { Home } from '../../interfaces/page';

@Component({
  selector: 'app-home-section-contact',
  templateUrl: './home-section-contact.component.html',
  styleUrls: ['./home-section-contact.component.scss']
})
export class HomeSectionContactComponent implements OnInit {
  @Input() content: Home;

  constructor() { }

  ngOnInit() {
  }

}
